import React from 'react';
import moment from 'moment';

import SnippetPreview from './SnippetPreview';
import { formatDate, titleize } from 'utils';

const recipient = (active) => {
  const recipient = active.hasOwnProperty("dummy_contact") ? active.dummy_contact : active.recipient;
  recipient.name = recipient.hasOwnProperty("name") ? recipient.name : `${recipient.first_name} ${recipient.last_name}`;

  return <div>
    <strong>Recipient: </strong>
    {<span>{recipient.name}&nbsp;({recipient.email})</span>}
  </div>;
};

const replyTo = (active) => {
  return active.content.reply_to ? <div>
    <strong>Reply to: </strong>{active.content.reply_to}
  </div> : <div/>;
};

const cc = (active) => {
  return active.content.reply_to ? <div>
    <strong>CC: </strong>{active.content.cc_emails}
  </div> : <div/>;
};

const bcc = (active) => {
  return active.content.reply_to ? <div>
    <strong>BCC: </strong>{active.content.bcc_emails}
  </div> : <div/>;
};

const subject = (active) => {
  return active.content.subject ? <div>
    <strong>Subject: </strong>{active.content.subject}
  </div> : <div/>;
};

const schedule = (scheduledAt) => {
  // Moment can't format just times so we have to make a datetime
  let dateTime = null;
  if ( scheduledAt && scheduledAt.schedule_type === 'scheduled' ){
    dateTime = scheduledAt.date + " " + scheduledAt.time;
  }
  return scheduledAt && scheduledAt.schedule_type === 'scheduled' ? <div>
    <strong>Scheduled At:</strong> {formatDate(scheduledAt.date)} at {moment(dateTime).format("h:mm A")}
  </div> : <div/>;
};

export default ({scheduledAt, ...props}) => <SnippetPreview header={
  (previewContent) => <div>
    {recipient(previewContent)}
    {schedule(scheduledAt)}
    {subject(previewContent)}
    {replyTo(previewContent)}
    {cc(previewContent)}
    {bcc(previewContent)}
  </div>
} {...props} />;
